// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ADvi","title":"styles_title__2EoNE"};